import { gql } from "@apollo/client";
import { Query } from "@apollo/client/react/components";
import { compose, graphql, ApolloProvider } from "@apollo/client/react/hoc";

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";

import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add User
const GQLAddUser = gql`
  mutation addUser(
    $type: String
    $firstName: String
    $lastName: String
    $email: String
    $password: String
    $aboutMe: String
    $numberNeighborhoodsReviewed: Int
    $like: Int
    $questionsAnswered: Int
    $point: Int
    $realEstateFirm: String
    $license: String
    $phone: String
    $isagent: String
    $ishomebuyer: String
    $ishomeseller: String
    $isneighbor: String
    $istopagent: String
    $userimage: String
    $streetaddress: String
    $city: String
    $state: String
    $zip: String
    $caption: String
    $displayname: String
  ) {
    createUser(
      type: $type
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      aboutMe: $aboutMe
      numberNeighborhoodsReviewed: $numberNeighborhoodsReviewed
      like: $like
      questionsAnswered: $questionsAnswered
      point: $point
      realEstateFirm: $realEstateFirm
      license: $license
      phone: $phone
      isagent: $isagent
      ishomebuyer: $ishomebuyer
      ishomeseller: $ishomeseller
      isneighbor: $isneighbor
      istopagent: $istopagent
      userimage: $userimage
      streetaddress: $streetaddress
      city: $city
      state: $state
      zip: $zip
      caption: $caption
      displayname: $displayname
    ) {
      success
      message
    }
  }
`;

//Update User
const GQLUpdateuser = gql`
  mutation updateUser(
    $email: String
    $firstName: String
    $lastName: String
    $displayname: String
    $mainemail: String
    $realEstateFirm: String
    $license: String
    $phone: String
    $aboutMe: String
    $userimage: String
    $streetaddress: String
    $city: String
    $state: String
    $zip: String
  ) {
    UpdateUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      displayname: $displayname
      realEstateFirm: $realEstateFirm
      license: $license
      phone: $phone
      aboutMe: $aboutMe
      userimage: $userimage
      streetaddress: $streetaddress
      city: $city
      state: $state
      zip: $zip
      mainemail: $mainemail
    ) {
      success
      message
    }
  }
`;

const GQLUpdateuserpassword = gql`
  mutation updateUserpassword($email: String, $password: String) {
    UpdateUserpassword(password: $password, email: $email) {
      success
      message
    }
  }
`;

const GQLUpdateuserdisplayname = gql`
  mutation updateUserdisplayname($email: String, $displayname: String) {
    UpdateUserdisplayname(displayname: $displayname, email: $email) {
      success
      message
    }
  }
`;

const GQLUpdateUserstatus = gql`
  mutation UpdateUserstatus($email: String, $status: Int) {
    UpdateUserstatus(status: $status, email: $email) {
      success
      message
    }
  }
`;

const GQLUpdateuserimage = gql`
  mutation updateUserimage(
    $email: String
    $userimage: String
    $caption: String
  ) {
    UpdateUserimage(userimage: $userimage, caption: $caption, email: $email) {
      success
      message
    }
  }
`;

//Delete User
const GQLDeleteUser = gql`
  mutation deleteUser($id: String!, $email: String) {
    deleteUser(id: $id, email: $email) {
      success
      message
    }
  }
`;

const GQLDeletePhoto = gql`
  mutation deletePhoto($id: String!, $email: String) {
    deletePhoto(id: $id, email: $email) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getAllUserList = gql`
  query getUser(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getUser(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      type
      firstName
      lastName
      email
      aboutMe
      numberNeighborhoodsReviewed
      likes
      questionsAnswered
      points
      realEstateFirm
      license
      phone
      aboutMe
      isagent
      ishomebuyer
      ishomeseller
      isneighbor
      istopagent
      userimage
      point_used
      displayname
    }
  }
`;

// const QUERY_getUser = gql`
// query getUser($id:String){
//     getUser(id:$id){
//         type
//         firstName
//         lastName
//         email
//         password
//         aboutMe
//         numberNeighborhoodsReviewed
//         like
//         questionsAnswered
//         point
//         realEstateFirm
//         license
//         phone
//         aboutMe
//         isagent
//         ishomebuyer
//         ishomeseller
//         isneighbor
//         istopagent
//         userimage
//     }
// }
// `;

const QUERY_getUsers = gql`
  query getUsers($start: Int, $limit: Int, $orderBy: String, $order: String) {
    getUsers(start: $start, limit: $limit, orderBy: $orderBy, order: $order) {
      id
      type
      firstName
      lastName
      email
      aboutMe
      numberNeighborhoodsReviewed
      like
      questionsAnswered
      point
      realEstateFirm
      license
      phone
      aboutMe
      isagent
      ishomebuyer
      ishomeseller
      isneighbor
      istopagent
      userimage
      point_used
    }
  }
`;

const QUERY_getAgents = gql`
  query getAgents($start: Int, $limit: Int, $orderBy: String, $order: String) {
    getAgents(start: $start, limit: $limit, orderBy: $orderBy, order: $order) {
      id
      firstName
      lastName
      aboutMe
      userimage
      realEstateFirm
      points
      license
    }
  }
`;

const QUERY_getUserVerificationStatus = gql`
  query getUserVerificationStatus(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
  ) {
    getUserVerificationStatus(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
    ) {
      statusCode
      message
      status
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addUser(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddUser,

        variables: {
          type: adddata.type,
          firstName: adddata.firstName,
          lastName: adddata.lastName,
          email: adddata.email,
          password: adddata.password,
          aboutMe: adddata.aboutMe,
          numberNeighborhoodsReviewed: adddata.numberNeighborhoodsReviewed,
          like: adddata.like,
          questionsAnswered: adddata.questionsAnswered,
          point: adddata.point,
          realEstateFirm: adddata.realEstateFirm,
          license: adddata.license,
          phone: adddata.phone,
          isagent: adddata.isagent,
          ishomebuyer: adddata.ishomebuyer,
          ishomeseller: adddata.ishomebuyer,
          isneighbor: adddata.isneighbor,
          istopagent: adddata.istopagent,
          userimage: adddata.userimage,
          streetaddress: adddata.streetaddress,
          city: adddata.city,
          state: adddata.state,
          zip: adddata.zip,
          caption: adddata.caption,
          displayname: adddata.displayname,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateUser(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateuser,
        variables: {
          email: updatedata.email,
          firstName: updatedata.firstName,
          lastName: updatedata.lastName || "",
          displayname: updatedata.displayname || "",
          mainemail: updatedata.mainemail,
          realEstateFirm: updatedata.realEstateFirm || "",
          license: updatedata.license || "",
          phone: updatedata.phone || "",
          aboutMe: updatedata.aboutMe || "",
          userimage: updatedata.userimage || "",
          streetaddress: updatedata.streetaddress || "",
          city: updatedata.city || "",
          state: updatedata.state || "",
          zip: updatedata.zip || "",
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateUserpassword(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateuserpassword,
        variables: {
          email: updatedata.email,
          password: updatedata.password,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateUserdisplayname(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateuserdisplayname,
        variables: {
          email: updatedata.email,
          displayname: updatedata.displayname,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function UpdateUserstatus(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateUserstatus,
        variables: {
          email: updatedata.email,
          status: updatedata.status,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateUserimage(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateuserimage,
        variables: {
          email: updatedata.email,
          userimage: updatedata.userimage,
          caption: updatedata.caption,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deleteUser(deletedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteUser,
        variables: {
          id: deletedata.id,
          email: deletedata.email,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function deletePhoto(deletedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeletePhoto,
        variables: {
          id: deletedata.id,
          email: deletedata.email,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Get list by own query
async function getAllUserList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllUserList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getUsers(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getUsers,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getAgents(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAgents,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getUserVerificationStatus(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getUserVerificationStatus,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// async function getUser(getdata){
//   return new Promise((resolve,reject) => {client.query({
//     query: QUERY_getUser,
//     options:{
//       fetch: fetch
//     },
//     variables:{
//       "id":getdata.id
//     },
//     context:CONTEXT
//   }).then(result => {resolve(result); })
//   .catch(error => {reject(error); })
// })
// }

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addUser,
  updateUser,
  deleteUser,
  getAllUserList,
  getUsers,
  updateUserpassword,
  updateUserdisplayname,
  UpdateUserstatus,
  updateUserimage,
  getAgents,
  getUserVerificationStatus,
  deletePhoto,
};
